import { Chat } from '@mint-sdk/api-ai-assistant';

import { ReasoningStep } from '../types/reasoningSteps.js';
import { isAiMessage } from '../types/typeGuards.js';

export const groupReasoningSteps = (
  chatMessages: Chat.ChatMessageRecordType[],
): ReasoningStep[] => {
  const aiMessages = chatMessages.filter(isAiMessage);
  const groupMap = new Map<string, ReasoningStep>();

  for (const msg of aiMessages) {
    const { eventType, metadata } = msg.message.additionalMetadata;

    if (!metadata?.reasoningGroupId) {
      continue;
    }

    const { reasoningGroupId } = metadata;
    const isGroupExist = groupMap.has(reasoningGroupId);

    if (!isGroupExist && eventType === 'message') {
      continue;
    }

    if (!isGroupExist) {
      groupMap.set(reasoningGroupId, {
        isDone: false,
        messageId: 0,
        data: [],
      });
    }

    const group = groupMap.get(reasoningGroupId);

    if (group) {
      if (eventType === 'message') {
        group.isDone = true;
        group.messageId = msg.messageId;
        continue;
      }

      group.data.push(msg);
    }
  }

  return Array.from(groupMap.values());
};

export const getChatMessages = (allMessages: Chat.ChatMessageRecordType[]) => {
  return allMessages.filter(({ message }) => {
    const { type, additionalMetadata } = message;

    const humanMessage = type === 'human';

    const aiMessage =
      type === 'ai' &&
      (!additionalMetadata.eventType ||
        additionalMetadata.eventType === 'message');

    return humanMessage || aiMessage;
  });
};
